module.exports = __webpack_public_path__ + "static/img/b2.6694e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2.png
// module id = TGLZ
// module chunks = 1